"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _reactRouterDom = require("react-router-dom");

var _ChevronButton = _interopRequireDefault(require("../button/ChevronButton"));

var _StringOrRender = _interopRequireDefault(require("../helper/StringOrRender"));

var _StaggeredFadeIn = _interopRequireDefault(require("../effect/animation/StaggeredFadeIn"));

var _styling = require("../../toolkit/styling");

var _dimen = require("../../toolkit/dimen");

var _providers = require("../../toolkit/providers");

var _class, _class2, _class3, _temp, _class4, _class5, _class6, _temp2, _class7, _class8, _class9, _temp3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DefaultPrefixedPadding = 35;

var SideMenuItem = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(SideMenuItem, _Component);

  var _super = _createSuper(SideMenuItem);

  function SideMenuItem() {
    var _this;

    (0, _classCallCheck2["default"])(this, SideMenuItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(SideMenuItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          href = _this$props.href,
          onClick = _this$props.onClick,
          selected = _this$props.selected,
          isInternallyHandledLink = _this$props.isInternallyHandledLink,
          style = _this$props.style,
          classNameProp = _this$props.className;
      var textBlack = this.context.theming.theme.textBlack;
      var className = (0, _styling.css)(this.styles.root, selected && this.styles.selected, classNameProp, style);

      var renderInner = function renderInner() {
        if (href) {
          return /*#__PURE__*/_react["default"].createElement("a", {
            href: href,
            style: {
              color: textBlack
            }
          }, /*#__PURE__*/_react["default"].createElement(_StringOrRender["default"], {
            value: title
          }));
        }

        return /*#__PURE__*/_react["default"].createElement(_StringOrRender["default"], {
          value: title
        });
      };

      if (isInternallyHandledLink && href) {
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
          to: href,
          className: className
        }, /*#__PURE__*/_react["default"].createElement(_StringOrRender["default"], {
          value: title
        }));
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: className,
        onClick: onClick
      }, renderInner());
    }
  }, {
    key: "styles",
    get: function get() {
      var prefixedPadding = this.props.prefixedPadding;
      var _this$context$theming = this.context.theming,
          _this$context$theming2 = _this$context$theming.theme,
          textBlack = _this$context$theming2.textBlack,
          hoverColor = _this$context$theming2.hoverColor,
          hoverBackground = _this$context$theming2.hoverBackground,
          fonts = _this$context$theming.fonts;
      return _aphrodite.StyleSheet.create({
        root: {
          fontSize: 16,
          lineHeight: 1.25,
          paddingTop: 15,
          paddingBottom: 15,
          paddingLeft: prefixedPadding,
          paddingRight: 15,
          cursor: "pointer",
          color: textBlack,
          fontFamily: fonts.semibold,
          ":hover": {
            color: hoverColor,
            backgroundColor: hoverBackground
          },
          userSelect: "none",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis"
        },
        selected: {
          color: hoverColor,
          backgroundColor: hoverBackground
        }
      });
    }
  }]);
  return SideMenuItem;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.defaultProps = {
  prefixedPadding: DefaultPrefixedPadding,
  isInternallyHandledLink: false
}, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var SideMenuSection = (0, _mobxReact.observer)(_class4 = (_class5 = (_temp2 = _class6 = /*#__PURE__*/function (_Component2) {
  (0, _inherits2["default"])(SideMenuSection, _Component2);

  var _super2 = _createSuper(SideMenuSection);

  function SideMenuSection() {
    var _this2;

    (0, _classCallCheck2["default"])(this, SideMenuSection);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _this2.context = void 0;
    return _this2;
  }

  (0, _createClass2["default"])(SideMenuSection, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          title = _this$props2.title,
          expanded = _this$props2.expanded,
          onExpandToggled = _this$props2.onExpandToggled,
          children = _this$props2.children,
          className = _this$props2.className,
          style = _this$props2.style,
          _this$props2$prefixed = _this$props2.prefixedPadding,
          prefixedPadding = _this$props2$prefixed === void 0 ? 0 : _this$props2$prefixed;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root, className, style)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.titleContainer),
        onClick: function onClick() {
          if (onExpandToggled != null) {
            onExpandToggled(!expanded);
          }
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.title)
      }, /*#__PURE__*/_react["default"].createElement(_StringOrRender["default"], {
        value: title
      })), this.expandable && /*#__PURE__*/_react["default"].createElement(_ChevronButton["default"], {
        direction: expanded ? "down" : "right",
        size: 12,
        onClick: function onClick() {
          if (onExpandToggled != null) {
            onExpandToggled(!expanded);
          }
        }
      })), expanded && _react["default"].Children.map(children, function (child) {
        if (! /*#__PURE__*/_react["default"].isValidElement(child)) {
          return null;
        }

        return /*#__PURE__*/_react["default"].cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
          prefixedPadding: prefixedPadding + 15
        }));
      }));
    }
  }, {
    key: "expandable",
    get: function get() {
      var _this$props3 = this.props,
          expanded = _this$props3.expanded,
          onExpandToggled = _this$props3.onExpandToggled;
      return onExpandToggled != null && expanded != null;
    }
  }, {
    key: "styles",
    get: function get() {
      var prefixedPadding = this.props.prefixedPadding;
      var _this$context$theming3 = this.context.theming,
          _this$context$theming4 = _this$context$theming3.theme,
          textBlack = _this$context$theming4.textBlack,
          hoverColor = _this$context$theming4.hoverColor,
          hoverBackground = _this$context$theming4.hoverBackground,
          fonts = _this$context$theming3.fonts;
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch"
        },
        titleContainer: {
          paddingTop: 15,
          paddingBottom: 15,
          paddingLeft: prefixedPadding,
          paddingRight: 15,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: this.expandable ? "pointer" : undefined,
          ":hover": {
            color: this.expandable ? hoverColor : undefined,
            backgroundColor: this.expandable ? hoverBackground : undefined
          }
        },
        title: {
          fontSize: 16,
          lineHeight: 1.25,
          color: textBlack,
          fontFamily: fonts.semibold,
          userSelect: "none",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis"
        }
      });
    }
  }]);
  return SideMenuSection;
}(_react.Component), _class6.contextType = _providers.LegoContext, _class6.defaultProps = {
  prefixedPadding: DefaultPrefixedPadding
}, _temp2), ((0, _applyDecoratedDescriptor2["default"])(_class5.prototype, "expandable", [_mobx.computed], Object.getOwnPropertyDescriptor(_class5.prototype, "expandable"), _class5.prototype), (0, _applyDecoratedDescriptor2["default"])(_class5.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class5.prototype, "styles"), _class5.prototype)), _class5)) || _class4;

var SideMenu = (0, _mobxReact.observer)(_class7 = (_class8 = (_temp3 = _class9 = /*#__PURE__*/function (_Component3) {
  (0, _inherits2["default"])(SideMenu, _Component3);

  var _super3 = _createSuper(SideMenu);

  function SideMenu() {
    (0, _classCallCheck2["default"])(this, SideMenu);
    return _super3.apply(this, arguments);
  }

  (0, _createClass2["default"])(SideMenu, [{
    key: "render",
    value: function render() {
      var _DimenStore$instance = _dimen.DimenStore.instance(),
          isSmallScreen = _DimenStore$instance.isSmallScreen;

      var _this$props4 = this.props,
          animate = _this$props4.animate,
          className = _this$props4.className,
          style = _this$props4.style,
          childrenProp = _this$props4.children;

      var children = _react["default"].Children.toArray(childrenProp).filter(function (e) {
        return /*#__PURE__*/_react["default"].isValidElement(e);
      });

      if (children.length == 0) {
        return null;
      }

      if (isSmallScreen) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(_StaggeredFadeIn["default"], {
        disabled: !animate,
        className: (0, _styling.css)(this.styles.root, className, style)
      }, children);
    }
  }, {
    key: "styles",
    get: function get() {
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          overflowY: "auto"
        }
      });
    }
  }]);
  return SideMenu;
}(_react.Component), _class9.Item = SideMenuItem, _class9.Section = SideMenuSection, _class9.propDoc = {
  animate: {
    required: false,
    defaultValue: "true",
    type: "boolean",
    description: "Indicates whether menu items should animate into appearance"
  }
}, _class9.defaultProps = {
  animate: true
}, _class9.demoRender = "\n<SideMenu>\n  <SideMenu.Item\n    title=\"Campaign basics\"\n    href=\"#\"\n  />\n  <SideMenu.Item\n    title=\"Products\"\n    href=\"#\"\n    selected={true}\n  />\n  <SideMenu.Item\n    title=\"Budget\"\n    href=\"#\"\n  />\n</SideMenu>\n  ", _temp3), ((0, _applyDecoratedDescriptor2["default"])(_class8.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class8.prototype, "styles"), _class8.prototype)), _class8)) || _class7;

var _default = SideMenu;
exports["default"] = _default;